module.exports = __webpack_public_path__ + "img/44.16e22ab4.jpg";